import { Link } from 'react-router-dom';
import { CHAIN_ID, EXPLORER_BASE, RPC_URL_138 } from '@/config';
import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '@/api/client';
import type { NetworksResponse } from '@/api/types';

export function HomePage() {
  const { data, isError } = useQuery({
    queryKey: ['networks'],
    queryFn: () => fetchApi<NetworksResponse>('/api/v1/networks'),
    staleTime: 60_000,
  });

  const n138 = data?.networks?.find((x) => x.chainIdDecimal === CHAIN_ID);

  return (
    <>
      <h1>DeFi Oracle Meta Mainnet</h1>
      <p className="lead">
        Public hub for compliant <strong>c*</strong> tokens on Chain {CHAIN_ID}, the{' '}
        <strong>cW*</strong> bridged registry on partner networks, live PMM pools, bridge routing, and
        single-hop atomic swaps via DODOPMMIntegration.
      </p>

      <div className="card-grid">
        <Link to="/tokens" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h3>c* &amp; cW*</h3>
          <p>Canonical Chain {CHAIN_ID} tokens from the API plus bridged cW* addresses per chain.</p>
        </Link>
        <Link to="/pools" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h3>Pools</h3>
          <p>Indexed liquidity from token-aggregation (refreshes with indexer).</p>
        </Link>
        <Link to="/swap" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h3>Atomic swap</h3>
          <p>Quote + wallet: approve and call swapExactIn on the integration contract.</p>
        </Link>
        <Link to="/routing" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h3>Routing</h3>
          <p>CCIP WETH bridge table and cross-chain token mapping for 138.</p>
        </Link>
      </div>

      <h2>Network</h2>
      {isError && (
        <p className="muted">
          Could not load <span className="mono">/api/v1/networks</span> — check API base URL and CORS.
          Default RPC below still works for wallets.
        </p>
      )}
      <div className="table-wrap">
        <table className="data">
          <tbody>
            <tr>
              <th>Chain ID</th>
              <td className="mono">{CHAIN_ID}</td>
            </tr>
            <tr>
              <th>RPC (fallback)</th>
              <td className="mono">{RPC_URL_138}</td>
            </tr>
            <tr>
              <th>Explorer</th>
              <td>
                <a href={EXPLORER_BASE}>{EXPLORER_BASE}</a>
              </td>
            </tr>
            {n138 && (
              <>
                <tr>
                  <th>Name (API)</th>
                  <td>{n138.chainName}</td>
                </tr>
                <tr>
                  <th>RPC (API)</th>
                  <td className="mono">{n138.rpcUrls?.[0] ?? '—'}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
